import { version } from "$app/env";
import { navigating, updated } from "$app/state";

const RELOADED_FROM_BUILD = "colossus.reloaded-from-build";

export const claimFreshLoad = (): boolean => {
  try {
    if (sessionStorage.getItem(RELOADED_FROM_BUILD) === version) return false;
    sessionStorage.setItem(RELOADED_FROM_BUILD, version);
    return true;
  } catch {
    return false;
  }
};

const loadFreshBuild = async (here: URL | null): Promise<void> => {
  if (!(await updated.check())) return;
  const target = navigating.to?.url ?? here;
  if (target !== null && claimFreshLoad()) location.assign(target);
};

export const reloadForRequestedChunk = (): Promise<void> => loadFreshBuild(new URL(location.href));

const requestedByUser = new WeakSet<EventTarget>();

let activating = false;

const markActivation = (): void => {
  activating = true;
  setTimeout(() => (activating = false));
};

const isActivationKey = (event: KeyboardEvent): boolean =>
  event.key === "Enter" || event.key === " ";

const noteRequestedLinks = (records: readonly MutationRecord[]): void => {
  if (!activating) return;
  for (const record of records) {
    for (const node of record.addedNodes) {
      if (node instanceof HTMLLinkElement) requestedByUser.add(node);
    }
  }
};

const isModulePreload = (target: EventTarget | null): target is HTMLLinkElement =>
  target instanceof HTMLLinkElement && target.rel === "modulepreload";

export const recoverFromMissingChunks = (): void => {
  addEventListener("click", markActivation, true);
  addEventListener(
    "keydown",
    (event) => {
      if (isActivationKey(event)) markActivation();
    },
    true,
  );
  new MutationObserver(noteRequestedLinks).observe(document.head, { childList: true });
  addEventListener("vite:preloadError", () => void loadFreshBuild(null));
  addEventListener(
    "error",
    ({ target }) => {
      if (!isModulePreload(target)) return;
      void loadFreshBuild(requestedByUser.has(target) ? new URL(location.href) : null);
    },
    true,
  );
};

export const stopPreloadingStaleRoutes = (): void => {
  if (updated.current) document.body.dataset["sveltekitPreloadData"] = "off";
};
